import React from "react";

const useIsomorphicLayoutEffect =
	typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;

/**
 * In ChakraUI, you can use 'useMediaQuery', but it is not that great and can cause re-renders
 * which we do not want. With the new way, we do not have to rerender and wait till everything is
 * loaded correctly.
 * 
 * @param {number} pixels The amount of pixels you want to listen to
 * @return {boolean} if the target pixel is reached or under.
 */
export const useSmallerThanQuery = (pixels: number) => {
	const [targetReached, setTargetReached] = React.useState(false);

	const updateTarget = React.useCallback(e => {
		if (e.matches) {
			setTargetReached(true);
		} else {
			setTargetReached(false);
		}
	}, []);

	useIsomorphicLayoutEffect(() => {
		const media = window.matchMedia(`(max-width: ${pixels}px)`);
		media.addListener(updateTarget);

		// Check on mount (callback is not called until a change occurs)
		if (media.matches) {
			setTargetReached(true);
		}

		return () => media.removeListener(updateTarget);
	}, []);

	return targetReached;
};